import { Injectable } from '@angular/core';
import { Address } from '../models/address';
import { PersonService } from './person.service';

@Injectable({
    providedIn: 'root'
})
export class AddressService {

    constructor(
        private personService: PersonService
    ) {}

    getAddress(parent_id: number, type: string): Address {
        switch(type){
            case 'person':
                return this.personService.getPerson(parent_id).address;
        }
    }
}